module.exports = __webpack_public_path__ + "img/music.d4be2988.png";